import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as merch from '@webapp/sdk/merch';
import { Actions } from '../../actions';
import {
  ListMerchCatalog,
  ListMerchCatalogError,
  ListMerchCatalogSuccess,
} from '../action-creators';
import { LIST_MERCH_CATALOG } from '../actions';

export const getCatalogEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, ListMerchCatalog>(LIST_MERCH_CATALOG),
    mergeMap(async () => {
      try {
        const response = await merch.listCatalog();
        //catalog not having colors in it
        return new ListMerchCatalogSuccess(response);
      } catch (err) {
        return new ListMerchCatalogError(err.message);
      }
    })
  );
